import { createContext, useEffect, useState } from "react";
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../../utils/baseUrl";
import { Navigate } from "react-router-dom";
import moment from 'moment';


const AuthContext = createContext();
export const AuthContextProvider = ({ children }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(() => {
    if (localStorage.getItem("tokens")) {
      let tokens = JSON.parse(localStorage.getItem("tokens"));
      return jwt_decode(tokens.access_token);
    }
    return null;
  });
 
  const login = async (payload) => {
    const apiResponse = await axios.post(
      `${baseUrl}/colaborador/login`,
      payload
    );
    localStorage.setItem("tokens", JSON.stringify(apiResponse.data));
    const loginData = {
      loginTime: moment(), // Obtenha a data atual com Moment.js
    };
    localStorage.setItem("loginData", JSON.stringify(loginData));
    setUser(jwt_decode(apiResponse.data.access_token));
    navigate("/");
  };

  const logout = async () => {
    // invoke the logout API call, for our NestJS API no logout API
    localStorage.removeItem("tokens");
    setUser(null);
    return <Navigate to="/login"></Navigate>;
  };

  useEffect(() => {
    const checkLoginTime = () => {
      const loginDataStr = localStorage.getItem("loginData");
      if (loginDataStr) {
        const loginData = JSON.parse(loginDataStr);
        const loginTime = moment(loginData.loginTime);
        const currentTime = moment();
        const fiveDays = moment.duration(5, 'days');
  
        // Verifique se já se passaram 5 dias desde o login
        if (currentTime.diff(loginTime) >= fiveDays) {
          // Realize o logout e redirecione para a tela de login
          logout();
          navigate("/login");
        }
      }
    };
  
    checkLoginTime();
  
    // Verifique a cada X minutos (por exemplo, a cada 1 hora)
    const interval = setInterval(checkLoginTime, 1 * 60 * 1000);
  
    // Limpe o intervalo quando o componente for desmontado
    return () => clearInterval(interval);
  }, [navigate]);

  const handleTermo = (valor) => {
    // Obtenha o objeto user atual
    const currentUser = { ...user }; // Crie uma cópia do objeto para não modificar o estado diretamente
  
    // Altere a propriedade "termo" para true
    currentUser.termo = valor;
  
    // Atualize o estado com o novo objeto modificado
    setUser(currentUser);
  };
  return (
    <AuthContext.Provider value={{ user, login, logout, handleTermo }}>
      {children}
    </AuthContext.Provider>
  );
};
 
export default AuthContext;